import Vue from 'vue'
import Vuex from 'vuex'

Vue.use(Vuex)


const LOGIN_INFO = "loginInfo"
const storage = sessionStorage

export default new Vuex.Store({
  state: {
    counter: 30,
    loginInfo: undefined,
    menuItems: undefined,
  },

  getters: {
    tripleCounter: state => state.counter * 3,

    loginInfo: state => {
      let loginInfo = state.loginInfo
      if (loginInfo && loginInfo.userId) {
        return loginInfo
      } else {
        const loginInfoStr = storage.getItem(LOGIN_INFO)
        if (loginInfoStr) {
          state.loginInfo = JSON.parse(loginInfoStr)
          return state.loginInfo
        } else {
          return undefined
        }
      }
    },
  },


  mutations: {

    increment: (state, num) => {
      state.counter += num
    },

    login: (state, loginInfo) => {
      state.loginInfo = loginInfo
      loginInfo.loginTime = new Date().getTime()
      storage.setItem(LOGIN_INFO, JSON.stringify(loginInfo))
    },

    logout: (state) => {
      state.loginInfo = undefined
      storage.removeItem(LOGIN_INFO)
      state.menuItems = undefined
    },
    updateToken: (state, jwtToken) => {
      const loginInfo = state.loginInfo
      if (loginInfo) {
        loginInfo.jwtToken = jwtToken
        loginInfo.loginTime = new Date().getTime()
        storage.setItem(LOGIN_INFO, JSON.stringify(loginInfo))
      }
    },
    updateMenuItems: (state, menuItems) => {
      state.menuItems = menuItems
    },
  },

  actions: {

    asyncDecrement: ({ commit }, asyncNum) => {
      setTimeout(() => {

        commit('decrement', asyncNum.by)
      }, asyncNum.duration)
    }
  }
})





// WEBPACK FOOTER //
// ./src/store/index.js